import '../../style/caet/fonts/NotoSerif/notoSerifFonts.scss';
import React, { Fragment } from 'react';

import { CaetThemeBasic, type IProps as ICaetBasicProps } from './basic';

const CaetRecognition = (props: ICaetBasicProps) => {
    const { children = null, ...rest } = props;

    return (
        <CaetThemeBasic {...rest}>
            <Fragment>{children}</Fragment>
        </CaetThemeBasic>
    );
};

export { CaetRecognition };
